export default __webpack_public_path__ + "static/media/FiraSans-Bold.3919333f.ttf";